import React from 'react';
import ReactDOM from 'react-dom';
import appstorelogo from '../assets/images/bigmall-app-modal/bigmall-app-appstore.png';
import huaweigallerylogo from '../assets/images/bigmall-app-modal/bigmall-app-huawei.png';
import googleplaylogo from '../assets/images/bigmall-app-modal/bigmall-app-playstore-1.png';
import qrcode from '../assets/images/bigmall-app-modal/BIGMALL-QR-CODE-300x300.png';
import chaticon from '../assets/images/bigmall-app-modal/icons8-chat-48.png';
import deliveryicon from '../assets/images/bigmall-app-modal/icons8-delivery-48.png';
import gifticon from '../assets/images/bigmall-app-modal/icons8-gifts-66.png';

const AppModal = ({ onClose }) => {
  return ReactDOM.createPortal(
    <div 
      className="modal show fade" 
      style={{ display: 'block', backgroundColor: 'rgba(255, 254, 237, 0.8)' }}
      tabIndex="-1" 
      role="dialog"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content" style={{ backgroundColor: '#ffeded' }}>
          <div className="modal-header">
            <h5 className="modal-title">Get the bigmall app to enjoy more benefits</h5>
            <button 
              type="button" 
              className="close-btn text-xl text-gray-700 ms-auto" 
              aria-label="Close" 
              onClick={onClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              {/* Row with icons and labels */}
              <div className="row text-center mb-3">
                <div className="col">
                  <img src={deliveryicon} alt="Fast Delivery" className="img-fluid" />
                  <div>Fast Delivery</div>
                </div>
                <div className="col">
                  <img src={chaticon} alt="Customer Support" className="img-fluid" />
                  <div>Customer Support</div>
                </div>
                <div className="col">
                  <img src={gifticon} alt="Special Events" className="img-fluid" />
                  <div>Special Events</div>
                </div>
              </div>
              <hr />
              {/* Row with QR code and app logos */}
              <div className="row">
                <div className="col-md-6">
                  <img src={qrcode} alt="QR Code" className="img-fluid" />
                </div>
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center gap-5">
                  <a href="https://play.google.com/store/apps/details?id=com.fourdiv.bigmall&pcampaignid=web_share" className="mb-2">
                    <img src={googleplaylogo} alt="Google Play" className="img-fluid" />
                  </a>
                  {/* <a href="https://urldra.cloud.huawei.com/rHAAmApjRC" className="mb-2">
                    <img src={huaweigallerylogo} alt="Huawei Gallery" className="img-fluid" />
                  </a> */}
                  <a href="https://apps.apple.com/lk/app/bigmall-online-shopping-app/id6503951842">
                    <img src={appstorelogo} alt="App Store" className="img-fluid" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default AppModal;
